import AES from 'crypto-js/aes'
import utf8 from 'crypto-js/enc-utf8'
import SHA256 from 'crypto-js/sha256'
import appEnv from 'app-env'

// 暗号化に使用するkeyに（安全のため）付け足す文字
const PEPPER_KEY_HEAD: string = appEnv.PUB_PEPPER_KEY_OF_CIPHER ?? ''

/**
 * 暗号化処理を行うメソッド
 * @param target 暗号化したいobject
 * @param key 暗号・復号に使用するkey
 * @returns 暗号化された文字列
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const encrypt = (target: object | any[], key: string): string => {
  const encryptKey = PEPPER_KEY_HEAD + key
  const JSONString = JSON.stringify(target)
  const encryptedString = AES.encrypt(JSONString, encryptKey).toString()
  return encryptedString
}

/**
 * 復号処理を行うメソッド
 * @param encryptedString 暗号化されている文字列
 * @param key 暗号・復号に使用するkey
 * @returns 復号されたオブジェクト
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const decrypt = (encryptedString: string, key: string): any => {
  const decryptKey = PEPPER_KEY_HEAD + key
  const decryptedString = AES.decrypt(encryptedString, decryptKey).toString(utf8)
  const decryptedObject = JSON.parse(decryptedString)
  return decryptedObject
}

export const generateHash = (str: string): string => SHA256(str).toString()
